<template>
  <div class="dashboard__card dashboard__card--no-min" v-if="mainBanner || loaders.banners">
    <CardLoading v-if="loaders.banners"></CardLoading>
    <div class="dashboard__card-content" :class="{ 'loadingBlur': loaders.banners }">
      <div class="dashboard__card-header">
        <div class="dashboard__card-title">Fuel News</div>
        <div class="dashboard__card-title-icon dashboard__card-title-icon--fuel-news"><i class="fas fa-newspaper"></i></div>
      </div>
      <div class="row dashboard__card-body dashboard__card-body--no-min">
        <div class="dashboard__grid dash-banners__content-container" v-if="mainBanner">
          <div class="col-xs-12 dashboard__card-body-col dashboard__card-body-col--bordered">
            <div class="dash-banners__list h-center-align">
              <NewsBanner :banner="mainBanner"></NewsBanner>
            </div>
          </div>
        </div>
        <div class="dashboard__grid dashboard__alert alert alert-warning" v-else>
          <div class="dashboard__no-data">No Fuel news available</div>
        </div>
      </div>
      <div class="row dashboard__card-body dashboard__card-body--no-min" v-if="cardBanners.length > 0">
        <div class="dashboard__grid dash-banners__content-container" v-if="cardBanners">
          <template v-if="cardBanners.length === 1">
            <div class="col-xs-12 dashboard__card-body-col dashboard__card-body-col--bordered"  v-for="(banner, index) in cardBanners" :key="index" >
              <div class="dash-banners__list h-center-align">
                <NewsBanner :banner="banner" :key="index"></NewsBanner>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="col-xs-6 dashboard__card-body-col dashboard__card-body-col--bordered"  v-for="(banner, index) in cardBanners" :key="index" >
              <div class="dash-banners__list h-center-align">
                <NewsBanner :banner="banner" :key="index"></NewsBanner>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import lodash from 'lodash';
  import { mapGetters } from 'vuex';
  import CardLoading from './CardLoading.vue';
  import NewsBanner from '../../banners/NewsBanner.vue';

  export default {
    name: 'NewsBannersCard',
    components: {
      CardLoading,
      NewsBanner,
    },
    computed: {
      ...mapGetters('banners', ['loaders', 'mainBanner', 'banners']),
      cardBanners() {
        return lodash.take(this.banners, 2);
      },
    },
  };
</script>
